<script setup>
import { l } from '@js/utils/toolbox';
import { useChatApi } from './useChatApi';

const props = defineProps({
	modelValue: String,
	loading: Boolean
});

const emit = defineEmits(['update:modelValue', 'submit', 'focus']);

const userInput = ref(null);

const showDebug = ref(false);
const { newConversation, isEnabled } = useChatApi();

function handleNewConversation () {
	newConversation('input_button');
}

defineExpose({
	userInput
});

// const { messages } = useChatApi();
// const { setMarkdownExample } = useMarkdownExample(messages);

</script>

<template>
  <div class="chat-input-container">
    <form
      class="chat-input-form"
      @submit.prevent="emit('submit')"
    >
      <!-- <button
        type="button"
        class="chat-button"
        @click="setMarkdownExample"
      >
        <BaseIcon icon="leaves-outline" />
      </button> -->
      <button
        type="button"
        class="chat-button"
        :disabled="!isEnabled"
        @click="handleNewConversation"
      >
        <BaseIcon icon="plus" />
      </button>

      <input
        ref="userInput"
        :value="modelValue"
        :placeholder="isEnabled ? l('chat.input.placeholder') : l('chat.input.disabledPlaceholder')"
        :disabled="!isEnabled"
        class="message-input"
        @input="emit('update:modelValue', $event.target.value)"
        @focus="emit('focus')"
      >

      <!-- <button
        id="debug-button"
        type="button"
        class="chat-button"
        :aria-pressed="showDebug"
        :title="showDebug ? 'Hide debug' : 'Show debug'"
        @click="showDebug = !showDebug"
      >
        🐞
      </button> -->

      <button
        type="submit"
        class="send-button"
        :disabled="loading || !modelValue.trim()"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line
            x1="22"
            y1="2"
            x2="11"
            y2="13"
          />
          <polygon points="22 2 15 22 11 13 2 9 22 2" />
        </svg>
      </button>
    </form>
    <!-- <ChatDebugMenu
      v-if="showDebug"
      v-model:isVisible="showDebug"
    /> -->
  </div>
</template>

<style scoped lang="scss">
.chat-input-container {
  position: relative;
  z-index: 2;
  padding: 20px 24px;
  background: $container-bg;
  border-top: 1px solid $neutral-border-color;
}

.chat-input-form {
  height: 100%;
  display: flex;
  gap: 12px;
  align-items: center;
}

.message-input {
  flex: 1;
  padding: 14px 18px;
  border: 2px solid $neutral-border-color;
  border-radius: 24px;
  font-size: 15px;
  outline: none;
  transition: all 0.2s ease;
  background: $input-bg;

  &:focus {
    border-color: $main-btn-bg;
    background: $white;
    box-shadow: 0 0 0 3px rgba($main-btn-bg, 0.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

#debug-button {
  @include breakpoint_down(md) {
    display: none;
  }
}

.chat-button {
  width: 48px;
  height: 48px;
  border: 1px solid $neutral-border-color;
  border-radius: 50%;
  background: $input-bg;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 6px rgba($black, 0.08);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba($black, 0.12);
    background: lighten($input-bg, 2%);
  }

  &[aria-pressed="true"] {
    border-color: $main-btn-bg;
    box-shadow: 0 0 0 3px rgba($main-btn-bg, 0.12);
  }
}

.send-button {
  width: 48px;
  height: 48px;
  border: none;
  border-radius: 50%;
  background: linear-gradient(135deg, $main-btn-bg 0%, $brand-btn-bg 100%);
  color: $white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba($main-btn-bg, 0.3);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba($main-btn-bg, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
}

</style>
